import React from "react";
import PrivateRoute from "PrivateRoutes";
import { withRouter, Redirect } from "react-router";
const REPORT = React.lazy(() => import(/* webpackChunkName: "CommonMsgReports" */'./components'));


const CommonMessageReports = ({ match }) => {
    let key = match.params.type;
    let dataUrl = `/reporting/message/${key}`;
    if (dataUrl) {
        return (
            <REPORT
                key={key}
                dataUrl={key}
                // moduleName={moduleName}
                moduleName={key}
                moduleUrl={dataUrl}
            />
        );
    }
    return <Redirect to="/not-found" />;
};

const routes = () => (
    <React.Fragment>
        <PrivateRoute
            key={"/reporting/message/:type"}
            exact={true}
            path="/reporting/message/:type"
            component={CommonMessageReports}
        />
    </React.Fragment>
);

export default withRouter(routes);



// WEBPACK FOOTER //
// src/modules/screens/reporting/CommonMsgReports/routes.js